import { CARGO_RESIDUES_NOTE, GARBAGE_CATEGORIES } from '../types';

import s from './TrashCategoriesReference.module.scss';

export function TrashCategoriesReference() {
  return (
    <div className={s.root}>
      <h6 className={s.title}>Garbage Categories</h6>
      <ul className={s.grid}>
        {GARBAGE_CATEGORIES.map(({ code, label }) => (
          <li key={code} className={s.item}>
            <span className={s.code}>{code}.</span>
            <span className={s.label}>{label}</span>
          </li>
        ))}
      </ul>
      <p className={s.note}>
        <strong>Note:</strong> {CARGO_RESIDUES_NOTE}
      </p>
    </div>
  );
}
